import { render, staticRenderFns } from "./employeesDialogyh.vue?vue&type=template&id=3554b512&scoped=true&"
import script from "./employeesDialogyh.vue?vue&type=script&lang=ts&"
export * from "./employeesDialogyh.vue?vue&type=script&lang=ts&"
import style0 from "./employeesDialogyh.vue?vue&type=style&index=0&id=3554b512&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554b512",
  null
  
)

export default component.exports